export default __webpack_public_path__ + "5fa806ccf62a32936d6d73ed4eb6f755.png";